import { Fragment, useCallback, useState } from 'react'
import TwinCalendar from '..'
import './twincalendarstartend.sass'
import { flushSync } from 'react-dom'
import { StartEndDateOptTy, StartEndDateTy } from '../../../utils/globals/types'
import TwinTrans from '../../TwinTrans'
import { TwinCalendarStartEndChange } from './types'

interface TwinCalendarStartEndProps extends TwinCalendarStartEndLogicProps{
    minDate?: Date
    maxDate?: Date
    defaultActiveStartDate?: Date
}

const TwinCalendarStartEnd: React.FC<TwinCalendarStartEndProps> = ({ maxDate, minDate, defaultActiveStartDate, ...rest }) => {
    const { handleOnChange, activeStartDate, setActiveStartDate } = useTwinCalendarStartEndLogic({ ...rest })
    return (
        <div className='flex gap-33 date_range_selector_start_end'>
            <div>
                <span className='regular14'><TwinTrans transKey='dateStart'>Fecha inicio</TwinTrans></span>
                <TwinCalendar value={rest.start} minDate={minDate} maxDate={maxDate} onChange={(val) => handleOnChange(val, 'start')} />
            </div>
            <div>
                <span className='regular14'><TwinTrans transKey='dateEnd'>Fecha fin</TwinTrans></span>
                <TwinCalendar value={rest.end} minDate={rest.start} maxDate={maxDate} onChange={(val) => handleOnChange(val, 'end')} activeStartDate={activeStartDate} onActiveStartDateChange={(val) => setActiveStartDate(val.activeStartDate) } />
            </div>
        </div>
    )
}

interface TwinCalendarStartEndLogicProps extends StartEndDateTy {
    onChange: TwinCalendarStartEndChange
}

const useTwinCalendarStartEndLogic = ({ start, end, onChange }: TwinCalendarStartEndLogicProps) => {
    const [activeStartDate, setActiveStartDate] = useState(start)

    const handleOnChange = useCallback((value: Date, type: 'start' | 'end') => {
        flushSync(async () => {
            if (type === 'start') {
                setActiveStartDate(value)
                await onChange(value, 'end')
            }
            await onChange(value, type)
        })
    }, [onChange])

    return { handleOnChange, activeStartDate, setActiveStartDate }
}

interface TwinCalendarStartEndStateFullProps extends TwinCalendarStartEndStateFullLogicProps {
    nameStart: string
    nameEnd: string
}

export const TwinCalendarStartEndStateFull: React.FC<TwinCalendarStartEndStateFullProps> = ({start, end, nameStart, nameEnd, onChange, ...rest}) => {
    const { handleOnChangeDate, dateSelected } = useTwinCalendarStartEndStateFullLogic({ start, end, onChange })
    return (
        <Fragment>
            <TwinCalendarStartEnd onChange={handleOnChangeDate} end={dateSelected.end} start={dateSelected.start} {...rest} />
            <input type='hidden' value={dateSelected.start ? dateSelected.start.toDateString() : ''} name={nameStart} />
            <input type='hidden' value={dateSelected.end ? dateSelected.end.toDateString() : ''} name={nameEnd} />
        </Fragment>)
}

interface TwinCalendarStartEndStateFullLogicProps extends StartEndDateOptTy {
    onChange?: TwinCalendarStartEndChange
}

const useTwinCalendarStartEndStateFullLogic = ({start, end, onChange}: TwinCalendarStartEndStateFullLogicProps) => {
    const [dateSelected, setDateSelected] = useState<StartEndDateTy>({
        start: start || new Date(),
        end: end || new Date(),
    })
    
    const handleOnChangeDate: TwinCalendarStartEndChange = useCallback((value, type) => {
        setDateSelected((old) => {
            return { ...old, [type]: value }
        })
        onChange?.(value, type)
    }, [setDateSelected, onChange])

    return {handleOnChangeDate, dateSelected}
}


export default TwinCalendarStartEnd